// Copyright 2017 Sorama B.V.

import { VideoFrame } from "datatypes/SoramaLocalApi";
import { GenericMeasurement } from "datatypes/SoramaWebApi";

export abstract class IMeasurementVideoFileService {
    /**
     * Get video frames for a measurement
     * @param measurement Measurement to get video frames for
     * @param partIndex Optional index of part to get frames for
     * @param callback Optional Progress callback function
     * @param startTime Optional start time in s
     * @param duration Optional duration in s
     */
    public abstract getVideoFrames(
        measurement: GenericMeasurement,
        partIndex?: number,
        callback?: (progress: number) => void,
        startTime?: number,
        duration?: number
    ): Promise<VideoFrame[][]>;
}
